/* global Office, document */

import { getTypesForDept, loadTemplates, state } from "./template-core";
import { bindContentEvents, openSaveDialog, renderTabs, renderTypes, renderView } from "./template-ui";

Office.onReady(async (info) => {
        if (info.host !== Office.HostType.Outlook) {
        isInOutlook();
        return;
    }

    await initApp();
});

function isInOutlook() {
   document.addEventListener("DOMContentLoaded", () => {
    document.body.innerHTML = `
    <div style="
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg);
      color: var(--text);
      font-family: inherit;
      padding: 16px;
    ">
      <div style="
        width: 420px;
        max-width: 92%;
        background: var(--card);
        border-radius: 14px;
        box-shadow: 0 10px 30px var(--shadow-card);
        border-left: 5px solid var(--accent-dark);
        padding: 22px;
        text-align: center;
      ">

        <div style="
          font-size: 42px;
          margin-bottom: 8px;
        ">📧</div>

        <div style="
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 6px;
          color: var(--text);
        ">
          Outlook Add-in Required
        </div>

        <div style="
          font-size: 13px;
          color: var(--muted);
          line-height: 1.5;
          margin-bottom: 14px;
        ">
          This application only works inside Microsoft Outlook.<br/>
          Please install the add-in and open it from Outlook.
        </div>

        <div style="
          background: var(--card-tabs);
          border-left: 3px solid var(--accent);
          padding: 10px 12px;
          border-radius: 10px;
          font-size: 12px;
          color: var(--text);
          margin-bottom: 16px;
          text-align: left;
        ">
          <strong style="color: var(--accent-dark);">Tip:</strong>
          Open Outlook → Get Add-ins → Installed Apps → Launch from there
        </div>

        <button onclick="window.open('https://www.microsoft.com/microsoft-365/outlook', '_blank')"
          style="
            background: var(--accent);
            color: white;
            border: none;
            padding: 10px 14px;
            border-radius: 10px;
            cursor: pointer;
            font-weight: 600;
            box-shadow: 0 2px 10px var(--shadow-card);
            transition: 0.2s;
          "
          onmouseover="this.style.transform='translateY(-2px)'"
          onmouseout="this.style.transform='translateY(0)'"
        >
          Learn More
        </button>

      </div>
    </div>
  `;})
}


export async function initApp() {
    const loaded = await loadTemplates();

    if (!loaded) {
        return;
    }

    state.activeDept = state.index.departments[0] || "";
    state.activeType = getTypesForDept(state.activeDept)[0] || "";

    renderTabs(state.index.departments, state.activeDept);
    renderTypes(getTypesForDept(state.activeDept), state.activeType);
    renderView(state.activeDept, state.activeType);
    bindContentEvents();

    document.getElementById("saveToggle")
        ?.addEventListener("click", openSaveDialog);

    const toggle = document.getElementById("darkToggle");

    toggle?.addEventListener("click", () => {
        document.body.classList.toggle("dark");

        toggle.textContent =
            document.body.classList.contains("dark")
                ? "☀️"
                : "🌙";
    });
}